import cn from "classnames"
import React, { useEffect, useState } from "react"
import "./AccordionWithChildren.scss"

interface IAccordionWithChildren {
    className?: string
    classNameHeader?: string
    children: React.ReactNode
    header: string | React.ReactNode | ((isExpanded: boolean) => string | React.ReactNode)
    isHeaderSectionTitle?: boolean
    leftAlignHeader?: boolean
    arrowNextToHeader?: boolean
    headerExpandedText?: string
    isSimple?: boolean
    animate?: boolean
    onlyRenderVisibleChildren?: boolean
    ignoreHeaderClick?: boolean
    arrowLeftOfHeader?: boolean
    isInitiallyExpanded?: boolean
    isExpanded?: boolean
    expandedDidChange?: (isExpanded: boolean) => void
}

export const AccordionWithChildren = (props: IAccordionWithChildren) => {
    const [expanded, setExpanded] = useState(props.isInitiallyExpanded ?? false)

    useEffect(() => {
        if (props.isExpanded !== undefined && expanded !== props.isExpanded) {
            setExpanded(props.isExpanded)
        }
    }, [props.isExpanded])

    const clickHandler = () => {
        if (props.isExpanded === undefined) {
            setExpanded(!expanded)
        }
        if (props.expandedDidChange) {
            props.expandedDidChange(!expanded)
        }
    }

    return (
        <div
            className={cn("accordion-with-children-component", props.className, {
                simplified: props.isSimple,
                animate: props.animate,
                "header-left": props.leftAlignHeader,
                "header-arrow-next-to": props.arrowNextToHeader,
                "arrow-left-of-header": props.arrowLeftOfHeader,
            })}
        >
            <div
                className={cn(
                    "accordion-with-children-component__header",
                    props.isHeaderSectionTitle && "accordion-with-children-component__header--section-title",
                    props.ignoreHeaderClick && "accordion-with-children-component__header--ignore-click",
                    props.classNameHeader
                )}
                onClick={() => {
                    if (!props.ignoreHeaderClick) {
                        clickHandler()
                    }
                }}
            >
                <p>
                    {expanded && props.headerExpandedText
                        ? props.headerExpandedText
                        : typeof props.header === "function"
                        ? props.header(expanded)
                        : props.header}
                </p>
                <div
                    className={cn("arrow-container", { up: expanded }, { down: !expanded })}
                    onClick={() => {
                        if (props.ignoreHeaderClick) {
                            clickHandler()
                        }
                    }}
                >
                    {!(props.isSimple ?? false) && <i className="arrow" />}
                </div>
            </div>
            {(!props.onlyRenderVisibleChildren || expanded) && (
                <div className={cn("children", { expanded })}>{props.children}</div>
            )}
        </div>
    )
}
